<template>
  <el-select v-model="unitValue" @change="setRowUnit" :disabled="disabled">
    <el-option v-for="item in curUnitList" :key="JSON.stringify(item)"
               :label="item.unit" :value="item.id"/>
  </el-select>
</template>

<script>
/**
 * @Description: 单位选择方法
 * @Author: 菩萨蛮
 * @Date: 2021/3/23 9:21 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'SelectUnit',
  props: {
    unitList: {
      type: Array,
      default: () => []
    },
    goods: {
      type: Object,
      default: null
    },
    index: { type: Number, default: -1 },
    disabled: { type: Boolean, default: false},
    defaultId: { type: String, default: '' }
  },
  created() {
    this.setDefaultValue();
  },
  watch: {
    defaultId() {
      this.setDefaultValue();
    }
  },
  data() {
    return {
      curUnitList: [],
      unitValue: ''
    }
  },
  methods: {
    setDefaultValue() {
      this.unitValue = this.defaultId;
      this.setCurUnitList();
    },
    setCurUnitList() {
      if (this.goods && this.goods.width && this.goods.width > 0 && this.goods.weight  && this.goods.weight > 0) {
        this.curUnitList = this.unitList;
      } else {
        this.curUnitList = this.unitList.filter(item => !['千克', 'kg', '公斤'].includes(item.unit));
      }
    },
    setRowUnit(id) {
      const unitList = this.unitList.filter(unit => unit.id === id);
      if (unitList && unitList.length === 1) {
        const unit = unitList[0];
        this.$emit('setUnit', { index: this.index, unit });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
